import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { FindPurchasePlan, GetPurchasePlan } from './interface';
import { axiosInstance } from '../../../client';

export const findPurchasePlan = createAsyncThunk(
  'purchasePlan/findPurchasePlan',
  async (values: FindPurchasePlan, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/purchase-plan');

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPurchasePlan = createAsyncThunk(
  'purchasePlan/getPurchasePlan',
  async ({ id }: GetPurchasePlan, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/purchase-plan/${id}`);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
